import { toast } from "react-toastify"

import { useLazyDeleteNewOrderQuery, useLazyGetOrdersQuery } from "store/api/ordersApi"

import getErrorMessage from "utils/getErrorMessage"

import { DeleteModal } from "../DeleteModal"

interface Props {
  orderId: number
  onCancel: () => void
}

export const DeleteOrderModal = ({ orderId, onCancel }: Props) => {
  const [triggerDeleteNewOrder, { isFetching }] = useLazyDeleteNewOrderQuery()
  const [triggerGetOrders] = useLazyGetOrdersQuery()

  const onSubmit = async (event: React.FormEvent<HTMLElement>) => {
    event.preventDefault()

    try {
      const res = await triggerDeleteNewOrder(orderId)
      const error = getErrorMessage(res?.error)
      if (error) {
        toast.error(error)
      } else {
        toast.success("Order has been successfully deleted!")
        triggerGetOrders({})
        onCancel()
      }
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <DeleteModal
      title="Delete order"
      message="Are you sure you want to delete the selected order(s)?"
      isFetching={isFetching}
      onCancel={onCancel}
      onConfirm={onSubmit}
    />
  )
}
